export default {
    // misc
    LOCAL_STORAGE_KEY: 'MoPCheckInApp',

    // auth
    TEST_MODE:         "TEST_MODE",
    LOGIN:             "LOGIN",
    TRYING_LOGIN:      "TRYING_LOGIN",
    LOGIN_ERROR:       "LOGIN_ERROR",
    LOGGED_IN:         "LOGIN_ERROR",
    LOGOUT:            "LOGOUT",
    
    // search
    SEARCH_STARTED:    "SEARCH_STARTED",
    SEARCH_COMPLETED:  "SEARCH_COMPLETED",
    SEARCH_CRITERIA:   "SEARCH_CRITERIA",
    SEARCH_CLEAR:      "SEARCH_CLEAR",
    SEARCH_ERROR:      "SEARCH_ERROR",

    // checkin
    CHECKIN_STARTED:   "CHECKIN_STARTED",
    CHECKIN_COMPLETED: "CHECKIN_COMPLETED",
    CHECKIN_ERROR:     "CHECKIN_ERROR",
    
    // morphing data
    UPDATE_PARTICIPANT: "UPDATE_PARTICIPANT",
};

export const participantSelect = [
    '*',
    // 'Models_of_Pride_2024_Registration_MOP_32.Emergency_Contact_Name', // 2024 Emergency Contact
    // 'Models_of_Pride_2024_Registration_MOP_32.Emergency_Contact_Phone_Number', // 2024 Emergency Contact
    // 'Youth_Registration_2025_MOP_33.Emergency_Contact_Name', // 2025 Emergency Contact
    // 'Youth_Registration_2025_MOP_33.Emergency_Contact_Phone_Number', // 2025 Emergency Contact
    'Youth_Registration_2026_MOP_34.Emergency_Contact_Name', // 2026 Emergency Contact
    'Youth_Registration_2026_MOP_34.Emergency_Contact_Phone_Number', // 2026 Emergency Contact
    // 'Models_of_Pride_2024_Registration_MOP_32.Models_of_Pride_2024_Release_of_Liability', // 2024 Youth Release
    // 'PPI_Registration_2024_MOP_32.Models_of_Pride_32_Release_of_Liability', // 2024 PPI Liability Release
    'Youth_Registration_2025_MOP_33.Models_of_Pride_2025_Release_of_Liability', // 2025 Youth Release
    'PPI_Registration_2025_MOP_33.By_clicking_Yes_I_agree_to_the_a_href_https_modelsofpride_org_mo', // 2025 PPI Liability Release
    'event_id.*'
];